exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.stack-container[data-v-bb390932] {\n  position: relative;\n  height: auto;\n}\n.stack-container:hover .stacked-image[data-v-bb390932] {\n  right: 0 !important;\n  top: calc(var(--i) * 3rem) !important;\n}\n.stacked-image[data-v-bb390932] {\n  position: absolute;\n  transition: all 0.3s ease;\n  --i: 0;\n}\n.stacked-image[data-v-bb390932]:nth-child(n + 1) {\n  --i: calc(var(--i) + 1);\n}\n", ""]);

// exports
